const PokeType = ({ type }) => {
  return <p> {type.name}</p>;
};

export default PokeType;
